import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { GUIDES, guideBody } from '../taxGuides';
let configCache = null;

/** /tax (the list of guides) and /tax/{slug} (one guide), built from the calculator's own figures */
export default class TaxGuidePage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.slug = m.route.param('slug') || null;
    this.guide = this.slug ? GUIDES.find(g => g.slug === this.slug) : null;
    this.config = configCache;
    this.error = null;
    app.setTitle(this.guide ? this.guide.title : 'Tax guides');
    if (!this.config) {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/voucha-calculators/tax/config'
      }).then(r => this.config = configCache = r && r.success ? r.countries : null).catch(() => this.error = 'Could not load the tax figures. Please try again shortly.').then(() => m.redraw());
    }
  }
  view() {
    const go = href => e => {
      if (!e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        m.route.set(href);
      }
    };
    const others = GUIDES.filter(g => g !== this.guide);
    return m('.VouchaCalculator.container.VouchaTaxGuide', [m('h4.App-titleControl.App-titleControl--text', this.guide ? this.guide.short : 'Tax guides'), m('a.VouchaTaxGuide-back', {
      href: '/tax',
      onclick: go('/tax')
    }, this.guide ? '← All tax guides' : null), m('h1', this.guide ? this.guide.title : 'Tax guides'), !this.guide && this.slug ? m('p', 'There is no guide at this address.') : null, this.guide ? this.config ? guideBody(this.guide.slug, this.config) : this.error ? m('p.VouchaCalculator-error', this.error) : m(LoadingIndicator) : null, this.guide ? m('p.VouchaTaxInfo-note', 'A guide, not tax advice: your own tax depends on your full circumstances. Figures for the ' + (this.config && this.config[this.guide.country] && this.config[this.guide.country].settings && this.config[this.guide.country].settings.taxYear || '2026') + ' tax year.') : null, m('section.VouchaTaxGuide-more', [m('h2', this.guide ? 'More tax guides' : 'Income tax, explained'), m('ul', (this.guide ? others : GUIDES).map(g => m('li', m('a', {
      href: '/tax/' + g.slug,
      onclick: go('/tax/' + g.slug)
    }, g.title)))), m('p', [m('a.Button.Button--primary', {
      href: '/tax-calculator',
      onclick: go('/tax-calculator')
    }, 'Work out your take-home pay')])])]);
  }
}
flarum.reg.add('voucha-calculators', 'forum/components/TaxGuidePage', TaxGuidePage);